import { Language } from '../../../../../shared/types/language.enum'
import { SettingsState } from './settings-state.interface'

export const createSettingsState = (): SettingsState => {
  return {
    locale: Language.English
  }
}
